import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService, SyncStatus } from 'app/document/services/document.service';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { InitializeLoadScreenComponent } from '../initialize-load-screen/initialize-load-screen.component';

@Component({
  selector: 'sync-status',
  templateUrl: './sync-status.component.html',
  styleUrls: ['./sync-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SyncStatusComponent implements OnInit, OnDestroy {
  SyncStatusEnum = SyncStatus;
  syncStatus: SyncStatus;
  private sub: Subscription;

  constructor(
    private dialog: MatDialog,
    private documentService: DocumentService,
    private cdr: ChangeDetectorRef,
  ) {}

  /**
   * Subscribe to this.service.syncStatus
   */
  ngOnInit() {
    // detach from angular change detection
    this.cdr.detach();
    this.sub = this.documentService.syncStatus.pipe(distinctUntilChanged()).subscribe((result: SyncStatus) => {
      this.syncStatus = result;

      // trigger change detection
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  /**
   * Opens sync log, but does not perform a sync!
   */
  openSyncLog() {
    this.dialog.open(InitializeLoadScreenComponent, {
      width: '500px',
      maxWidth: '90vw',
      disableClose: false,
      closeOnNavigation: true,
      data: {
        sync: false,
        autoClose: false,
        label: 'Sync Status',
        message: 'Toggle Details to see sync log messages',
        buttonText: 'Close',
        downloadingState: false,
        progressBar: false,
      },
    });
  }
}
